export const checkBetaDataExists = (item, property) => {
  let value = item?.beta_value_data?.[property]?.beta_data
  if (value === undefined) value = 'NA'
  return value
}
